/* oxlint-disable no-param-reassign -- https://redux-toolkit.js.org/usage/immer-reducers */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import {
  draftRegistrationSchema,
  registrationSchema,
  suggestedRegistrationSchema,
} from '~/utils/schemas';
import { reset } from './sharedActions';

export const registrationsStateSchema = z.object({
  suggested: suggestedRegistrationSchema.nullable().default(null),
  draft: draftRegistrationSchema.nullable(),
  registration: registrationSchema.nullable(),
  referrer: z.string().nullable().default(null),
});

type RegistrationsState = z.infer<typeof registrationsStateSchema>;

const initialState: RegistrationsState = {
  draft: null,
  registration: null,
  suggested: null,
  referrer: null,
};

export const registrationsSlice = createSlice({
  name: 'registrations',
  initialState,
  reducers: {
    setDraft: (state, action: PayloadAction<RegistrationsState['draft']>) => {
      state.draft = action.payload;
      state.registration = null;
    },
    setReferrer: (
      state,
      action: PayloadAction<RegistrationsState['referrer']>,
    ) => {
      state.referrer = action.payload;
    },
    setRegistration: (
      state,
      action: PayloadAction<RegistrationsState['registration']>,
    ) => {
      state.draft = null;
      state.registration = action.payload;
      state.suggested = null;
    },
    setSuggested: (
      state,
      action: PayloadAction<RegistrationsState['suggested']>,
    ) => {
      state.suggested = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, () => initialState);
  },
});
